import { isUndNullEmp } from '../../helpers/main.js';

export class Configuration {
    constructor(
        _id = 0,
        _name = '',
        _paginated = 0,
        _fromDateTime = '',
        _toDateTime = '',
        _success = 0,
        _warning = 0,
        _danger = 0,
        _isValid = false,
        _register = '',
    ) {
        this.id = _id;
        this.name = _name;
        this.paginated = _paginated;
        this.fromDateTime = _fromDateTime;
        this.toDateTime = _toDateTime;
        this.success = _success;
        this.warning = _warning;
        this.danger = _danger;
        this.isValid = _isValid;
        this.register = _register;
    }

    static getClassName = () => {
        return 'Configuration - class';
    }

    static minMaxLength = (upperCase = false) => {
        if (upperCase) {
            return {
                min: {
                    Id: 1,
                    Name: 2,
                    Paginated: 0,
                    FromDateTime: 10,
                    ToDateTime: 10,
                    Success: 0,
                    Warning: 0,
                    Danger: 0,
                    IsValid: 1,
                    Register: 10,
                },
                max: {
                    Id: 450,
                    Name: 50,
                    Paginated: 999,
                    FromDateTime: 30,
                    ToDateTime: 30,
                    Success: 999,
                    Warning: 999,
                    Danger: 999,
                    IsValid: 1,
                    Register: 10,
                }
            };
        } else {
            return {
                min: {
                    id: 1,
                    name: 2,
                    paginated: 0,
                    fromDateTime: 10,
                    toDateTime: 10,
                    success: 0,
                    warning: 0,
                    danger: 0,
                    isValid: 1,
                    register: 10,
                },
                max: {
                    id: 450,
                    name: 50,
                    paginated: 999,
                    fromDateTime: 30,
                    toDateTime: 30,
                    success: 999,
                    warning: 999,
                    danger: 999,
                    isValid: 1,
                    register: 10,
                }
            };
        }
    }

    static getClass = (obj = {}, upperCase = false) => {
        if (!isUndNullEmp({ data: obj, subMethod: this.getClassName() })?.result) {
            if (upperCase) {
                return new Configuration(
                    obj.Id,
                    obj.Name,
                    obj.Paginated,
                    obj.FromDateTime,
                    obj.ToDateTime,
                    obj.Success,
                    obj.Warning,
                    obj.Danger,
                    obj.IsValid,
                    obj.Register,
                );
            } else {
                return new Configuration(
                    obj.id,
                    obj.name,
                    obj.paginated,
                    obj.fromDateTime,
                    obj.toDateTime,
                    obj.success,
                    obj.warning,
                    obj.danger,
                    obj.isValid,
                    obj.register,
                );
            }
        } else {
            return new Configuration();
        }
    }
}